import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuth } from '@core/auth/useAuth'
import { abrirSessaoPartilhada } from './partilharSessao'
import { useProgressoDaSessao } from './sessaoPartilhadaEstado'

/** `?sessao=<id>` no endereço abre a sessão partilhada (é a ligação do
 *  email e do aviso no sino, e o "Abrir" de "Partilhados comigo"). O
 *  parâmetro sai do endereço logo, para recarregar a página não a voltar
 *  a abrir. Mostra também o progresso enquanto os modelos descem.
 *  Montado uma vez no layout do workspace. */
export default function AbrirSessaoPeloEndereco() {
  const { mode, workspace, user } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const progresso = useProgressoDaSessao()
  const emCurso = useRef<string | null>(null)

  const id = new URLSearchParams(location.search).get('sessao')
  const pronto = mode === 'cloud' && !!workspace && !!user

  useEffect(() => {
    if (!id || !pronto || !workspace || !user) return
    if (emCurso.current === id) return
    emCurso.current = id
    const resto = new URLSearchParams(location.search)
    resto.delete('sessao')
    const procura = resto.toString()
    navigate(`${location.pathname}${procura ? `?${procura}` : ''}`, { replace: true })
    void abrirSessaoPartilhada(
      id,
      {
        workspaceId: workspace.id,
        workspaceSlug: workspace.slug,
        workspaceNome: workspace.name,
        utilizadorId: user.id,
        utilizadorNome: user.name || user.email,
      },
      () => navigate(`/${workspace.slug}/`),
    ).finally(() => {
      emCurso.current = null
    })
  }, [id, pronto, workspace, user, location.pathname, location.search, navigate])

  if (!progresso) return null
  return (
    <div
      role="status"
      className="fixed bottom-10 left-1/2 z-[1100] flex max-w-[90vw] -translate-x-1/2 items-center gap-2 rounded border border-[var(--color-accent-border)] bg-[var(--color-panel)] px-3 py-1.5 text-xs text-[var(--color-text)] shadow-lg"
    >
      <Loader2 size={12} className="shrink-0 animate-spin text-[var(--color-accent)]" aria-hidden />
      <span className="truncate">{progresso}</span>
    </div>
  )
}
